module.exports = __webpack_public_path__ + "media/images/logo-2-82ca767633e3935b630642377d136651.png";